import React, { useState, useEffect } from "react"
import { Tab, Tabs } from "react-bootstrap"

import RunsContainer from "../graphing/RunsContainer"
import { PageTitle } from "../../config/AppSettingsConfigProvider"
import { getTableTranslations } from "../../tables/utils"
import FiltersEditor from "../../shared_components/table_filter_editor/FiltersEditor"
import FavouritesTiles from "../../shared_components/favourites/FavouritesTiles"
import { logToServer } from "../../ErrorBoundary"
import { loadRunDetails } from "../../Loaders"
import { ExcelTravelerModal } from "../../shared_components/graphing/modals/ExcelTravelerButton"

export const table_class_name = "view_runs"
export const table_id_name = "view_runs"

export const translation_mapping = {
  experiments: { id: "general.project.experiments", default: "Experiments" },
  name: { id: "graphing.run.identifier", default: "Run Identifier" },
  reactor: { id: "general.reactor", default: "Reactor" },
  ...Object.fromEntries(
    ["inoculated_on", "Inoculated On"].map((key) => [
      key,
      { id: "fermmanagement.inoculated.on", default: "Inoculated On" },
    ]),
  ),
  ...Object.fromEntries(
    ["started_on", "Started On"].map((key) => [
      key,
      { id: "fermmanagement.started.on", default: "Started On" },
    ]),
  ),
  ...Object.fromEntries(
    ["finished_on", "Finished On"].map((key) => [
      key,
      { id: "fermmanagement.finished.on", default: "Finished On" },
    ]),
  ),
  placeholder: { id: "graphing.run.placeholder", default: "Placeholder" },
  id: { id: "general.id", default: "ID" },
  "Started By": { id: "fermmanagement.started.by", default: "Started By" },
  "Ended By": { id: "fermmanagement.ended.by", default: "Ended By" },
  ...Object.fromEntries(
    ["run_description", "Run Description"].map((key) => [
      key,
      { id: "general.description", default: "Description" },
    ]),
  ),
  "Run Comment": { id: "general.comment", default: "Comment" },
  "Biocatalyst Parent(s)": { id: "fermmanagement.inoculum.biocatalyst", default: "Biocatalyst Parent(s)" },
  "Run Parent(s)": { id: "fermmanagement.inoculum.run", default: "Run Parent(s)" },
  "External Sample Parent(s)": {
    id: "fermmanagement.inoculum.external.sample",
    default: "External Sample Parent(s)",
  },
  "External Run Parent(s)": {
    id: "fermmanagement.inoculum.external.run",
    default: "External Run Parent(s)",
  },
  "Earliest Data": {
    id: "fermmanagement.earliest.data",
    default: "Earliest Data",
  },
  "Latest Data": { id: "fermmanagement.latest.data", default: "Latest Data" },
  "Run Length": { id: "fermmanagement.run.length", default: "Run Length" },
}

export default function ArchivedDashboard({
  runs,
  updateRunList,
  onSearch,
  selectedRun,
  updateSelectedRun,
  intl,
}) {
  $(`#${table_id_name}`).on("load-success.bs.table expand-row.bs.table", () => {
    getTableTranslations(intl, table_class_name, translation_mapping)
  })

  getTableTranslations(intl, table_class_name, translation_mapping)

  return (
    <div className={"full-height"}>
      <div className={"content-block full-height-min"}>
        <PageTitle glyph={"th-list"} id={"navigation.archivedRunOption"} description={"Archived Runs"} />
        <Tabs defaultActiveKey={runs.length > 0 ? "viewGraphs" : "viewRunList"}>
          <Tab
            eventKey={"viewRunList"}
            title={intl.formatMessage({ id: "archiveddash.run.list" })}
            key={"viewRunList"}
          >
            <div className={"tab-body"} id={"run-list-tab-body"}>
              <div id={"error-banner"} />
              <FiltersEditor onSearch={onSearch} intl={intl} isRunView />
              <ExportExcelModal intl={intl} selectedRun={selectedRun} updateSelectedRun={updateSelectedRun} />
              <table
                id={table_id_name}
                className={table_class_name}
                style={{ marginTop: "5px", overflow: "hidden" }}
              />
            </div>
          </Tab>
          <Tab
            eventKey={"viewGraphs"}
            title={intl.formatMessage({ id: "archiveddash.view.graphs" })}
            key={"viewGraphs"}
          >
            <div
              className={"tab-body"}
              style={{
                padding: "30px 10px 100px",
                overflow: "hidden" /* To hide scrollable graphs */,
              }}
            >
              <RunsContainer runs={runs} updateRunList={updateRunList} id_accessor={"id"} intl={intl} />
            </div>
          </Tab>
          <Tab
            eventKey={"viewFavouriteRuns"}
            title={intl.formatMessage({ id: "favourites.manage.favourites" })}
            key={"viewFavouriteRuns"}
          >
            <div className={"tab-body"} id={"favourite-runs-tab"}>
              <FavouritesTiles intl={intl} />
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}

const ExportExcelModal = ({ intl, selectedRun, updateSelectedRun }) => {
  const [runInfo, setRunInfo] = useState({})
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (selectedRun) {
      // The Excel export button of one of the rows was clicked, grab the Excel export
      loadRunDetails(selectedRun, undefined)
        .then((resp) => {
          setRunInfo(resp)
        })
        .catch((err) => {
          console.error(err)
          logToServer(err)
        })
    }
  }, [selectedRun])

  useEffect(() => {
    // Once runInfo is updated in state, show the modal
    if (runInfo?.name) {
      setShow(true)
    }
  }, [runInfo])

  return (
    <ExcelTravelerModal
      intl={intl}
      show={show}
      setShow={setShow}
      runData={runInfo}
      customOnHide={() => {
        setRunInfo({})
        updateSelectedRun(null)
      }}
    />
  )
}
